<template>
      <div class="queryCondition">
          <div class="innerCondition">
            <div id="navTitle">{{titleName}}</div>
            <div id="company" v-if="showorg">
              <OrganizationalStructure :treelist="list" @changeVal="changeVal" :wide="200"/>
            </div>
            <el-date-picker
              v-model="dataRange"
              type="daterange"
              range-separator="-"
              value-format="yyyy-MM-dd"
              size="small"
              clear-icon=""
              @change="changeDate"
            >
            </el-date-picker>
            <el-select class="selectDate" v-model="valueDate" @change="getDatas">
            <el-option   v-for="item in options" :key="item.label " :label="item.label" :value="item.value">
            </el-option>
            </el-select>
          </div>
      </div>
</template>

<script>
import OrganizationalStructure from '@/components/OrganizationalStructure'
import * as Urls from '@/helper/Urls';
export default {
    components:{
        OrganizationalStructure,
    },
    props: {
      showorg: {
        type: Boolean,
        default: true
      },
      titleName: {
        type: String,
        default: ''
      },
      optionsVal:{
        Type:Boolean,
        default:false
      }
    },
    data() {
        return {
            dataRange: [], // 获取时间
            activeDay: '',
            valueDate:'month',
            options:[
              {
                value:'month',
                label:'本月'
              },
              {
                value:'prev',
                label:'本周'
              },
              {
                value:'all',
                label:'本年'
              }     
            ],      
            list: [], // 树形结构            
        };
    },
    methods:{
        changeVal(val){
            // 获取的数据传递
            this.$emit('changeVal',val)
        },
        //  获取组织结构数据
        getSysOrg(){
        let _this = this;
        let url = Urls.get_report_orgList;
        let params = '';
        this.$root.doPost(url,params,function(server_data){
            let data = server_data.data;
            data.forEach(item => {
                item.label = item.orgName;
                item.children.forEach(item2 => {
                    item2.label = item2.orgName;
                    if (item2.children) {
                        item2.children.forEach(item3 => {
                            item3.label = item3.orgName;
                        })
                    }
                })
            });
            _this.list = data;
         });
        },
        // 获取对应时间
        getDatas(day) {
        let start = new Date();
        let end = new Date();
        switch(day) {
            case 'all':    //本年
                let num = start.getFullYear()
                this.dataRange = [this.$root.formatDay(new Date(`${num}/1/1`).toLocaleDateString()), this.$root.formatDay(start.toLocaleDateString())];
                this.activeDay = day;
                this.$emit('changDate',this.dataRange)
                break;
            case 'month':                 //本月
                start.setDate(1);
                start.setHours(0);
                start.setSeconds(0);
                start.setMinutes(0);
                start.setTime(start.getTime());
                this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
                this.activeDay = day;  
                this.$emit('changDate',this.dataRange)
                break;
            case 'prev':                 //本周
                const nowTime = start.getDay() ? start.getDay() - 1 : 6
                const twoTime = start.getTime() - nowTime * 1000 * 60 * 60 * 24 
                this.dataRange = [this.$root.formatDay(new Date(twoTime).toLocaleDateString()), this.$root.formatDay(start.toLocaleDateString())];
                this.activeDay = day;  
                this.$emit('changDate',this.dataRange)
                break;
            case '':
                this.dataRange = [];
                this.activeDay = day;  
                this.$emit('changDate',this.dataRange)
                break;
            }
        },
        // 时间
        changeDate(val){
            this.$emit('changePicker',val)
        }
    },
    mounted(){
        if(this.$route.query.identification){
            let start = new Date();
            let end = new Date();
            start.setDate(1);
            start.setHours(0);
            start.setSeconds(0);
            start.setMinutes(0);
            start.setTime(start.getTime());
            this.dataRange = [this.$root.formatDay(start), this.$root.formatDay(end)];
           if(this.optionsVal){
            this.options.unshift({
              value:'',
              label:'全部'
            })
            this.valueDate = ''
            this.getDatas('');
          }
        }else{
        // 获取组织架构数据
        this.getSysOrg();
        if(this.optionsVal){
            this.options.unshift({
              value:'',
              label:'全部'
            })
            this.valueDate = ''
            this.getDatas('');
          }else{
            // 获取时间
            this.getDatas('month');
          }
        }    
    }
}
</script>

<style lang="scss" scoped>
    .queryCondition {
        position:absolute;
        top:0.15rem;
        right: 0.37rem;
        margin-bottom: 20px;
      .innerCondition {
        .el-date-editor .el-range__close-icon {
            display: none;
        }       
        .el-date-editor {
          .el-range__icon {
            display: none;
          }
        }
        #navTitle {
          display: none;
        }
        #company {
          display: inline-block;
          .el-input {
            width: 2rem;
            // margin-right: 1rem;
          }
        }     
      }
      .picker_year{
       margin-left: 0.1rem; 
      }     
     }
     @media screen and (max-width: 768px) {
        .queryCondition {
        position: relative;
        height: 0.4rem;
        width: 100%;
        background-color: #fff;
        border-top: 1px solid #f5f5f5;
        box-sizing: border-box;
        top: 0;
        right: 0;
        z-index: 99;
        .el-select.selectDate {
         width: 20%;
         position: absolute;
         top:-0.04rem;
         right: 0;
        }
        .innerCondition {
          width: 100%;
          display: flex;
          align-items: center;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          #navTitle {
            display: block;
            font-weight: 800;
            font-size: 0.16rem;
            margin-left: 0.1rem;

          }
          #company {
            width: 1.4rem;
            display: block;
            position: absolute;
            top: -0.45rem;
            right: 0.06rem;
          }
          .el-date-editor--daterange.el-input__inner {
            width: 0.46rem;
            border: none;
            padding: 0;
            position: absolute;
            right: 0.45rem;
          }
          .picker_year.el-dropdown {
            position: absolute;
            right: 0.04rem;
          }
        }
      } 
     }
</style>
<style lang="scss" >
    @media screen and (max-width: 768px) {
        .tree-input{
              width: 140px !important;
         }
        .el-input__inner {
            border: none;
            padding: 0;
            line-height: 13px;
        }
        .el-input__icon{
            line-height: 0.32rem;
        } 
        .el-input__suffix {
            right: 0.2rem;
        }
        .el-range-editor--small .el-range-separator {
            line-height: 0.3rem;
            padding: 0;
        }  
        .el-date-editor .el-range__icon {
            display: none;
        } 
        .el-select-dropdown.el-popper {
                top: 0.6rem  !important;
                left: 2.9rem !important;
        }
        .el-range-editor--small.el-input__inner {
                height: 0.2rem;
        }  
        .el-date-range-picker {
            width: 3.71rem;
            position: absolute !important;
            top: 0.77rem !important;
            left: 0.01rem !important;
            z-index: 2001 !important;
            .el-picker-panel__body{
              min-width: 3.71rem;
            }
            .el-date-range-picker__content {
              padding: 0.05rem;
            }
        } 
        .el-date-range-picker__header div {
          font-size: 0.12rem;
        }   
        .el-picker-panel__icon-btn{
          padding: 0;
        } 
        .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange.el-range-editor--small {
            width:202px !important;
            vertical-align: top !important;
            height: 33px !important;
        }
    }
    .queryCondition {
        .el-date-editor .el-range__close-icon {
            display: none;
        }
        .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange.el-range-editor--small {
            width:225px;
            vertical-align: top;
            height: 33px;
        }
        .el-input__inner {
          height: 33px;
          .el-input__icon {
            line-height:28px;
          }
        }
        i.el-select__caret.el-input__icon.el-icon-arrow-up {
          line-height: 28px;
        }
    }
</style>


// WEBPACK FOOTER //
// HeadControl.vue?49e7d7ac